import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LogInModal from 'flarum/forum/components/LogInModal';
import extractText from 'flarum/common/utils/extractText';

import revealablePassword from './utils/passwordReveal';

/**
 * El ojo mostrar/ocultar, también en «Acceder» (PKG-FORO-ADMIN-RESTORE).
 *
 * El registro y Configuración ya lo tienen (`utils/passwordReveal`); el modal de inicio de
 * sesión era la única contraseña del foro que seguía escribiéndose a ciegas. Mismo helper,
 * mismas clases `CmPwReveal`, mismas claves de copy — nada nuevo que traducir ni estilar.
 *
 * EL ESTADO VIVE EN LA INSTANCIA DEL MODAL (`cmPwShown`), como manda la nota del helper: quién
 * ve qué contraseña lo decide el formulario dueño. Se inicializa en `oninit`, así que abrir el
 * modal otra vez siempre arranca oculto.
 *
 * `items.replace` conserva la prioridad del item del core (20): el orden identificación →
 * contraseña → recordarme no se mueve. Los atributos replican los del core —incluido el
 * `bidi`, que es como el input sigue atado a `this.password`— y el helper pone el `type`
 * después del spread, que es todo su truco. El botón del ojo es `type="button"`: Enter sigue
 * enviando el formulario.
 */
export default function addLoginPasswordReveal() {
  extend(LogInModal.prototype, 'oninit', function (this: any) {
    this.cmPwShown = false;
  });

  extend(LogInModal.prototype, 'fields', function (this: any, items: any) {
    if (!items.has('password')) return;

    const passwordLabel = extractText(app.translator.trans('core.forum.log_in.password_placeholder'));

    items.replace(
      'password',
      <div className="Form-group">
        {revealablePassword(
          {
            className: 'FormControl',
            name: 'password',
            autocomplete: 'current-password',
            placeholder: passwordLabel,
            'aria-label': passwordLabel,
            bidi: this.password,
            disabled: this.loading,
          },
          !!this.cmPwShown,
          () => {
            this.cmPwShown = !this.cmPwShown;
            m.redraw();
          }
        )}
      </div>
    );
  });
}
